export default {
  _prepareDynamicCombo() {
    const dropdownStaticTarget = this._gp_refDropdownStatic;
    const dropdownResultsTarget = this._gp_refDropdownResults;
    const dropdownMessageTarget = this._gp_refDropdownMessage;
    const dropdownLoadingTarget = this._gp_refDropdownLoading;

    this._gp_refTextInput.addEventListener("input", (e) => {
      this.open = true;

      const query = e.currentTarget.value;
      if (!query) {
        dropdownResultsTarget.classList.add("tw-hidden");
        dropdownLoadingTarget.classList.add("tw-hidden");

        if (dropdownStaticTarget) {
          dropdownStaticTarget.classList.remove("tw-hidden");
          dropdownMessageTarget.classList.add("tw-hidden");
        } else {
          dropdownMessageTarget.classList.remove("tw-hidden");
        }

        return;
      }


      dropdownStaticTarget?.classList?.add("tw-hidden");
      dropdownResultsTarget.classList.add("tw-hidden");
      dropdownMessageTarget.classList.add("tw-hidden");
      dropdownLoadingTarget.classList.remove("tw-hidden");

      this.$refs.input.dispatchEvent(new CustomEvent("search", {
        detail: {
          query: query,
          showDropdownMessage: this._showDropdownMessage.bind(this),
          addDropdownItem: this._addDropdownItem.bind(this),
          clearDropdownItems: this._clearDropdownItems.bind(this),
        }
      }));
    });
  },


  _addDropdownItem(value, innerHTML = value) {
    if (value === undefined || value == null) {
      throw new Error("Dropdown items must have a valid non-null value!")
    }

    const dropdownItem = document.createElement("div");
    dropdownItem.classList.add("gecko-select-dropdown-item");
    dropdownItem.setAttribute("data-value", value);
    dropdownItem.setAttribute("x-on:click", "handleSelect");
    dropdownItem.innerHTML = innerHTML;

    if (this.value && Array.from(this.value).includes(String(value))) {
      dropdownItem.innerHTML += `<i class="fa fa-check gecko-select-selected"></i>`;
    }

    this._gp_refDropdownResults.appendChild(dropdownItem);
    return dropdownItem;
  },

  _clearDropdownItems() {
    this._gp_refDropdownLoading.classList.add("tw-hidden");
    this._gp_refDropdownMessage.classList.add("tw-hidden");

    this._gp_refDropdownResults.classList.remove("tw-hidden");
    this._gp_refDropdownResults.innerHTML = "";
  },

  _showDropdownMessage(message) {
    this._gp_refDropdownLoading.classList.add("tw-hidden");
    this._gp_refDropdownMessage.classList.remove("tw-hidden");

    if (message) {
      this._gp_refDropdownMessage.innerText = message;
    }
  },
};
